import defaultConfig from 'config/default-config.yaml';

import MojitoCore from 'mojito/core';

import {expandToStructure} from '#core/utils/config-utils.js';

import {configureSportsbook} from '#core/sportsbook-initializer.js';

import {actions as visualConfigActions} from '#core/application/modules/visual-config-actions.js';

import fonts from './config/fonts.yaml';
import {THEME_LIGHT} from './config/theme-light.js';
import {THEME_DARK} from './config/theme-dark.js';
import {getTokens} from './config/viewsconfig';

const {dispatch} = MojitoCore.Services.redux.store;

let theme =
    localStorage.getItem('theme') ?? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');

const darkTheme = expandToStructure(THEME_DARK);
const lightTheme = expandToStructure(THEME_LIGHT);

const applyTheme = themeName => {
    theme = themeName;

    document.documentElement.setAttribute('data-theme', themeName);
};

applyTheme(theme);

configureSportsbook({
    getTokensFn: getTokens,
    getRuntimeConfigFn: () => {
        return theme === 'dark' ? darkTheme : lightTheme;
    },
    customMessageHandler: ({switchToTheme}) => {
        applyTheme(switchToTheme);
        dispatch(visualConfigActions.rebuildAndApplyVisualFromConfig());
    },
    configuration: {
        ...defaultConfig,
        fonts,
    },
});
